module.exports = __webpack_public_path__ + "static/media/organizations.6a725c8f.svg";